import React, { useState, useEffect } from 'react';
import { ArrowRight } from 'lucide-react';

const HeroSection = () => {
  const [imageLoaded, setImageLoaded] = useState(false);
  
  const scrollToProducts = () => {
    document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' });
  };

  // Preload key images
  useEffect(() => {
    const images = ['/images/story1.png', '/images/story2.png', '/images/hero.png'];
    images.forEach(src => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  return (
    <section className="hero-section">
      <div className="hero-background">
        <div className="hero-glow"></div>
      </div>
      
      <div className="hero-content">
        <h1 className="hero-title">
          NAŠ NAJBOLJI<br />
          <span className="hero-title-accent">KIKIRIKI PUTER</span><br />
          DO SAD
        </h1>
        
        <p className="hero-subtitle">
          Jedinstvena receptura, od pažljivo biranih najfinijih prirodnih 
          sastojaka kako bismo dobili čist premium kvalitet.
        </p>
        
        <button className="hero-cta" onClick={scrollToProducts}>
          Kupi sada
          <ArrowRight size={18} />
        </button>
      </div>

      <div className="hero-image-container">
        {!imageLoaded && <div className="image-placeholder"></div>}
        <img
          src="/images/hero.png"
          alt="Premium kikiriki puter"
          className={`hero-image ${imageLoaded ? 'loaded' : 'loading'}`}
          onLoad={() => setImageLoaded(true)}
          loading="eager"
        />
        <div className="hero-image-glow"></div>
      </div>
    </section>
  );
};

export default HeroSection;
